import { render, staticRenderFns } from "./business-card-form-type-finishing.vue?vue&type=template&id=3e99c5f8&scoped=true&"
import script from "./business-card-form-type-finishing.vue?vue&type=script&lang=js&"
export * from "./business-card-form-type-finishing.vue?vue&type=script&lang=js&"
import style0 from "./business-card-form-type-finishing.vue?vue&type=style&index=0&id=3e99c5f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e99c5f8",
  null
  
)

export default component.exports